<template>
  <div>
    <v-card v-if="inventory">
      <v-card dark class="pa-2">
        <div class="text-center">
          <span class="subtitle-1">Last Updated At: </span>
          <span class="ml-1 font-weight-bold">{{ inventory.lastUpdateDate }}</span>
        </div>
      </v-card>
      <v-card class="mb-3" v-for="row in inventory.items_json" v-if="inventory.items_json">
        <v-card-text>
          <h1 class="title">{{ row.name }}</h1>
          <v-list>
            <template v-for="(item, index) in row.items">
              <v-list-item :key="index" avatar @click="viewLocation(item)">
                <v-list-item-content>
                  <v-list-item-title v-html="item.name"> </v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar>
                  <span>{{ item.sumOfQty }}</span>
                </v-list-item-avatar>
              </v-list-item>
              <v-divider> </v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-card>
    <v-card v-else>
      <v-card-text>
        NO Data Sync Yet
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import locationService from "../service.js";

export default {
  props: ["hidden", "locations", "hideHeader"],
  name: "location-list",
  data() {
    return {
      inventory: null,
      terminalURL: process.env.VUE_APP_TERMINALURL,
      headers: [
        {
          text: this.$t("labels.cspID"),
          align: "left",
          sortable: true,
          value: "CSPID"
        },
        {
          text: this.$t("labels.name"),
          value: "businessName",
          sortable: true
        },
        {
          text: this.$t("labels.address"),
          value: "address",
          sortable: false
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "address",
          sortable: false
        },
        {
          text: this.$t("labels.emailAddress"),
          value: "address",
          sortable: false
        }
      ],
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "businessName"
      }
    };
  },
  created() {
    return locationService
      .getInventory(this.location.CSPID)
      .then(response => {
        this.inventory = response;
        console.log("inventory", response);
      })
      .catch(err => {
        console.log("error", err);
      });
  },
  computed: {
    ...mapGetters("location", ["location", "cards", "service"])
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.locations.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    viewLocation(location) {
      if (!this.hideHeader) {
        this.setLocation(location.storeID);
        this.$router.push({ name: "location-profile" });
      }
    }
  }
};
</script>
